import React, { createContext, useState } from 'react';
import P from 'prop-types';
import { GlobalDadosApp, GlobalEnderecos, GlobalOpenPedidos, GlobalSacola, GlobalStatusLoja, GlobalUser } from './data';

export const GlobalContext = createContext();

export const HomeContext = ({ children }) => {
  const [dadosApp, setDadosApp] = useState(GlobalDadosApp);
  const [user, setUser] = useState(GlobalUser);
  const [enderecos, setEnderecos] = useState(GlobalEnderecos);
  const [statusLoja, setStatusLoja] = useState(GlobalStatusLoja);
  const [sacola, setSacola] = useState(GlobalSacola);
  const [openPedidos, setOpenPedidos] = useState(GlobalOpenPedidos);

  return (
    <GlobalContext.Provider
      value={{
        dadosApp,
        setDadosApp,
        user,
        setUser,
        statusLoja,
        setStatusLoja,
        sacola,
        setSacola,
        enderecos,
        setEnderecos,
        openPedidos,
        setOpenPedidos,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

HomeContext.propTypes = {
  children: P.node,
  //children: React.ReactNode,
};
